import { loadQuery } from 'react-relay';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import RelayEnvironment from 'lib/utils/relay';
import { getAccountId, getUserId } from 'lib/utils/authentication';
import { productsQuery } from 'services/product/__generated__/productsQuery.graphql';
import { PRODUCTS_QUERY } from 'services/product/product.relay.services';
import { contactsQuery } from 'services/contact/__generated__/contactsQuery.graphql';
import { CONTACTS_QUERY } from 'services/contact/contact.relay.services';

export const InvoiceCreatePreloadData = () => {
  const userId = getUserId();
  const accountId = getAccountId();

  const queryFilter = {
    or: {
      accountId: { equalTo: accountId },
      contactTeamMembers: {
        teamMember: { memberUserId: { equalTo: userId } },
      },
    },
    deletedAt: { isNull: true },
  };

  return {
    contactsQueryRef: loadQuery<contactsQuery>(RelayEnvironment, CONTACTS_QUERY, {
      first: 1000,
      ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
      filter: {
        where: queryFilter,
      },
    }),
    productsQueryRef: loadQuery<productsQuery>(RelayEnvironment, PRODUCTS_QUERY, {
      first: 100,
      filter: {
        where: {
          and: {
            accountId: { equalTo: accountId },
            deletedAt: { isNull: true },
          },
        },
      },
    }),
    userProfileRef: loadQuery<userProfileQuery>(RelayEnvironment, USER_PROFILE_QUERY, {
      id: userId,
      skip: !userId,
    }),
  };
};

export type InvoiceCreatePreloadDataType = ReturnType<typeof InvoiceCreatePreloadData>;
